import React from "react";
import "./qa.scss";
import { withRouter } from "react-router";
import { Row, Col } from "reactstrap";
import QACard from "../../common/cards/qaCard";

class QA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      device: "web",
      questionsLeft: [
        {
          title:
            "Does Toffee Insurance Plan cover pandemics like COVID-19 as well?",
          subtitle:
            "Glad you asked that. Yes, under its health insurance coverage, Toffee Insurance Plan covers all your hospitalisation expenses for COVID- 19, if tested positive. This coverage is not limited to just the current coronavirus (COVID-19) outbreak but extends to other diseases as well.",
          bgColor: "#fff"
        },
        {
          title: "OK, again, what is Toffee Insurance?",
          subtitle:
            "Toffee Insurance is insurance simplified. You can insure yourself, alone, or add on your family too - for health, life and household insurance. An all-in-one easy combo plan! \n\nInstead of figuring 3 different plans for your health, life and home, you can simply pick one Toffee plan depending upon whether you want the insurance for yourself (single) or for your family (up to 4 members, including yourself). Small, seamless monthly payments give you peace of mind and secure your and your family’s future.",
          bgColor: "#fffeea"
        },
        {
          title:
            "How is Toffee Insurance different from other Insurance providers? ",
          subtitle:
            "Toffee takes the headache out of choosing and using insurance. Toffee is a unique and exclusive combination of insurance products that are selected from the most trusted and top insurance companies. You get a unique combination of insurance benefits across health, life and household.",
          bgColor: "#fff"
        }
      ],

      questionsRight: [
        {
          title: "Why are you called Toffee? ",
          subtitle:
            "Funny you should ask that. We are called Toffee, because just like one, we offer sweet insurance benefits in smaller, bite-sized insurance plans. We make insurance simpler, faster and accessible for everyone. Sweet!\n\nWe believe insurance should be a good fit for your current needs and above all, should be easy. With our Toffee Insurance plan, we attempt the same by bringing a 3-in-1 plan that covers health, life and household for you in simple a-b-c steps.",
          bgColor: "#e7fbff"
        },
        {
          title:
            "I bought the Single Toffee Plan. When should I upgrade my policy? ",
          subtitle:
            "If you bought the Single Toffee Plan, ideally the first indication for you that it’s time to upgrade to our Family Toffee Plan is as and when you get married or have kids. With a quick switch, you can upgrade and insure the health of your loved ones (up to 4 family members) under the same Toffee insurance plan.",
          bgColor: "#fff"
        },
        {
          title:
            "What happens if I am unable to pay the premium for 1-2 months? Will my Toffee Plan be valid? ",
          subtitle:
            "Toffee looks out for you even after you’ve bought the plan. We offer to cover your monthly payments for up to X months, in case you miss your payment or are unable to do so. The payment Toffee makes on your behalf is easily adjusted in your next monthly cycle, so your payments keep going without causing you any inconvenience.",
          bgColor: "#ffe8ff"
        }
      ]
    };
  }
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  navigateToProduct() {
    this.props.history.push("/product/" + this.state.selectedPlan);
  }
  selectProduct(plan) {
    if (this.state.selectedPlan === plan) {
      this.state.device === "web" && this.navigateToProduct();
      return;
    }
    this.setState({
      selectedPlan: plan
    });
  }
  render() {
    return (
      <div className="qa-container">
        <h2 className="title opacity-90 text-center">
          Commonly Asked Questions
        </h2>
        <h3 className="sub-title">
          Got questions? We got answers to everything.
        </h3>
        <div className="box-container">
          <Row className="m-0 p-0">
            <Col lg="6" className="m-0 p-0 left-col">
              {this.state.questionsLeft.map(item => {
                return <QACard data={item} />;
              })}
            </Col>
            <Col lg="6" className="m-0 p-0 right-col">
              {this.state.questionsRight.map(item => {
                return <QACard data={item} />;
              })}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(QA);
